import { render } from "./WebFormFeedback.vue?vue&type=template&id=25ada556"
import script from "./WebFormFeedback.vue?vue&type=script&lang=js"
export * from "./WebFormFeedback.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__